import { Link } from '@tanstack/react-router';
import { products } from './products.ts';
import { bookDemoUrl, demoMailto, DEMO_EMAIL } from './contact.ts';

/**
 * The footer — identity, product index and contact, set on the Material 3
 * chrome tone so it reads as the page's closing surface. Space, not rules.
 */
export function SiteFooter(): JSX.Element {
  const link = 'text-sm text-muted-foreground transition-colors hover:text-foreground';

  return (
    <footer>
      <div className="folio-wide py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-[1.4fr_1fr_1fr]">
          <div className="max-w-xs">
            <div className="flex items-center gap-2.5">
              <img src="/icons/wapoffice-mark.svg" alt="" className="size-8" />
              <span className="head-dv text-xl">ވެޕްލިފައި އޮފީސް</span>
            </div>
            <p className="mt-4 text-sm leading-loose text-muted-foreground">
              ރަށު ކައުންސިލްތަކަށް ގުޅިފައިވާ އޮފީސް — ސޮއިކުރުން، ބައްދަލުވުންތައް އަދި
              ބޯހިމެނުން އެއް އެކައުންޓަކުން.
            </p>
          </div>

          <div>
            <p className="head-dv text-base">ޕްރޮޑަކްޓް</p>
            <div className="mt-4 flex flex-col gap-2.5">
              {products.map((p) => (
                <a key={p.key} href={p.url} target="_blank" rel="noreferrer" className={link}>
                  {p.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="head-dv text-base">ފަށާ</p>
            <div className="mt-4 flex flex-col gap-2.5">
              <a href={bookDemoUrl} target="_blank" rel="noreferrer" className={link}>
                ޑެމޯއަކަށް ރިކުއެސްޓްކުރޭ
              </a>
              <Link to="/login" className={link}>
                ލޮގިން
              </Link>
              <a href={demoMailto} dir="ltr" className={`${link} text-end`}>
                {DEMO_EMAIL}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">ވެޕްލިފައި · {new Date().getFullYear()}</p>
          <Link to="/security" dir="ltr" className={link}>
            Security
          </Link>
        </div>
      </div>
    </footer>
  );
}
